import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { Component, computed, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'crm-duration-custom-filter-chip',
  templateUrl: './duration-custom-filter-chip.component.html',
  providers: [],
  imports: [CommonModule, TranslateModule],
})
export class DurationCustomFilterChipComponent implements GalaxyAbstractFilterChip {
  selectedDurationMilliseconds = signal<number>(0);
  selectedDurationMillisecondsEnd = signal<number>(0);

  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    if (value?.length === 1 && value[0].integer) {
      this.selectedDurationMilliseconds.set(value[0].integer);
    } else {
      this.selectedDurationMilliseconds.set(value[0].integer);
      this.selectedDurationMillisecondsEnd.set(value[1].integer);
    }
  }

  selectedDurationText = computed(() => {
    if (this.selectedDurationMillisecondsEnd() > 0) {
      return (
        this.fromMilliseconds(this.selectedDurationMilliseconds()) +
        ' - ' +
        this.fromMilliseconds(this.selectedDurationMillisecondsEnd())
      );
    } else {
      return this.fromMilliseconds(this.selectedDurationMilliseconds());
    }
  });

  fromMilliseconds(milliseconds: number): string {
    const seconds = Math.floor((milliseconds / 1000) % 60);
    const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
    const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    return `${hours}h ${minutes}m ${seconds}s`;
  }
}
